
import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OccupancyEnum } from '@gtpl/shared-models/masters';
export class PalletUpdateDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Pallet No should not be empty" })
    palletNo: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Associate RFIS's should not be empty" })
    assocRfId: string;

    @ApiProperty({
        enum: OccupancyEnum,
        default: OccupancyEnum.NOT_OCCUPIED
    })
    @IsEnum(OccupancyEnum)
    occupancy: OccupancyEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Updated user should not be empty" })
    updatedUser : string;
}